import { atom } from 'jotai';
import { DEFAULT_SELECTION_LAYER_ATTRIBUTES } from '@/consts/selection';
import { EventDescription, VisEvent } from '@/types/event';
import { Nullable } from '@/types/generic';

export const activeRectAtom = atom(DEFAULT_SELECTION_LAYER_ATTRIBUTES);

export const resultRectAtom = atom(DEFAULT_SELECTION_LAYER_ATTRIBUTES);

export const selectedVisEventsAtom = atom<Nullable<VisEvent[]>>(null);

export const selectedEventDescriptionsAtom = atom<EventDescription[]>([]);

export const selectVisEventsAtom = atom(null, (_get, set, events: VisEvent[], descriptions: EventDescription[]) => {
  set(selectedVisEventsAtom, events);
  set(selectedEventDescriptionsAtom, descriptions);
});
